var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42857 11H14.0952H20.9762C21.6508 11 23 10.6364 23 9.18182C23 8.58853 22.6121 7.41445 21.0769 7.36523C21.0217 7.36346 20.9765 7.31835 20.9733 7.26321C20.8754 5.57452 18.3236 4.57489 16.7145 6.40043C16.6508 6.47271 16.5179 6.43093 16.5085 6.33502C16.384 5.06372 15.4638 3 12.4762 3C11.1428 3 8.49167 3.71032 8.42968 6.53492C8.42847 6.59014 8.38419 6.63619 8.32901 6.63846C7.49367 6.67288 6 7.14167 6 8.81818C6 9.54545 6.48571 11 8.42857 11Z",
    fill: "#737373",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 16H10.5238H18.619C19.4127 16 21 15.5455 21 13.7273C21 12.9833 20.5407 11.5086 18.72 11.456C18.6648 11.4544 18.6193 11.4091 18.6169 11.354C18.5236 9.21558 15.4704 7.94482 13.572 10.2911C13.5105 10.3672 13.3757 10.3258 13.3681 10.2283C13.2434 8.64499 12.1781 6 8.61905 6C7.04664 6 3.91657 6.89211 3.85798 10.4438C3.85707 10.4991 3.81254 10.5453 3.75735 10.5474C2.7781 10.5842 1 11.1647 1 13.2727C1 14.1818 1.57143 16 3.85714 16Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24 11L5 17.4615H7.8L5.88 23L11 16.5385H8.28L9.24 11Z",
    fill: "#CA8A04",
    stroke: "#FACC15",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11D);
export default __webpack_public_path__ + "static/media/11d.98ad92a62e2e99381ca5d267720988a9.svg";
export { ForwardRef as ReactComponent };